import config from 'react-global-configuration';

import type { AppOptions } from '../types';

export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const USE_SENTRY = process.env.REACT_APP_SENTRY_ENABLED?.toLowerCase() === "true";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const REACT_APP_VERSION = process.env.REACT_APP_VERSION;
export const SEARCH_PATH = String('/zoeken');
export const MULTILINGUAL = false;

export const DEFAULT_LANGUAGE = 'nl';
export const SITE_NAME = '<SITE NAME>';
export const APP_ROOT_ELEMENT_ID = 'root';

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

export let API_URL = process.env.REACT_APP_API_URL || '//netbeheernederland.devinc.eu';
export let SEARCHKIT_HOST_URL = process.env.REACT_APP_SEARCHKIT_HOST_URL || '/api-proxy/elasticsearch-proxy?_api_proxy_uri=';

config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': MULTILINGUAL,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'API_URL': API_URL,
  'PAGE_TRANSITION_SPEED': 200,
  'REACT_APP_VERSION': REACT_APP_VERSION,
}, { freeze: false });

export let APP_OPTIONS: AppOptions = {
  apiUrl: API_URL,
  element: '',
  parameters: {
    env: 'production',
    searchkitIndexAllContent: 'elasticsearch_index_netbeheer_content_all',
    searchkitIndexLocationsContent: 'elasticsearch_index_netbeheer_location_all_entities',
    searchkitIndexQualityMeasurementsContent: 'elasticsearch_index_netbeheer_qualitymeasurement_all',
    // Time-based decay configuration for search relevance scoring
    searchkitDecay: {
      articles: {
        value: 0.75,    // Score multiplier at scale distance (75% of original score)
        scale: '180d',  // Distance where decay value is applied (6 months)
        offset: '30d'   // No decay within this period from publication date (1 month)
      },
      documents: {
        value: 0.75,    // Score multiplier at scale distance (75% of original score)
        scale: '120d',  // Distance where decay value is applied (4 months) 
        offset: '30d'   // No decay within this period from creation date (1 month)
      },
    }
  }
};

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0; // xs
export const SCREEN_TABLET = 576; // sm
export const SCREEN_NORMAL = 768; // md
export const SCREEN_WIDE = 1200; // lg
export const SCREEN_HUGE = 1560; // xl

export const TAXONOMY_MEDIA_CATEGORY_MAGAZINE = 23;
export const TAXONOMY_MEDIA_CATEGORY_PUBLICATION = 24;
export const TAXONOMY_MEDIA_CATEGORY_CODE = 28;

export const BLOCK_RELATED_ARTICLES_BLOCK_ID = 3;
export const BLOCK_RELATED_THEMES_BLOCK_ID = 4;
export const BLOCK_RELATED_DOCUMENTS_BLOCK_ID = 5;
export const BLOCK_RELATED_THEME_ARTICLES_BLOCK_ID = 6;
export const BLOCK_NEWSLETTER_BLOCK_ID = 7;

// Map results
export const markerNames = {
  UHS: 'UHS',
  HS: 'HS',
  MS: 'MS',
  LS: 'LS',
  UNKNOWN: 'UNKNOWN'
};

// Content type constants
export const CONTENT_TYPES = {
  BASIC_PAGE: 'basic_page',
  LANDING_PAGE: 'landing_page',
  OVERVIEW_PAGE: 'overview_page',
  DOCUMENT: 'document',
  ARTICLE: 'article',
} as const;

export function saveConstants(options: AppOptions) {
  APP_OPTIONS = options;

  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
    SEARCHKIT_HOST_URL = 'http://localhost:3000/search';
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': MULTILINGUAL,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'API_URL': API_URL,
    'PAGE_TRANSITION_SPEED': 200,
    'REACT_APP_VERSION': REACT_APP_VERSION,
  });
}
